export default {
      id: "uspCard-wholeLifeCover-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-wholeLifeCover",
      toString: function () {
        return this.url;
      }
    }